// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"styles_disclaimer__2NGAZ"};